import { render } from "./OnlineShopping.m.vue?vue&type=template&id=1fac4543"
import script from "./OnlineShopping.m.vue?vue&type=script&lang=js"
export * from "./OnlineShopping.m.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__